import { logger } from "@repo/logs";
import { createPurchasesHelper } from "@repo/payments/lib/helper";
import { usePurchasesQuery } from "@saas/payments/lib/api";

export const usePurchases = (propertyId?: string, organizationId?: string) => {
	const { data: purchases } = usePurchasesQuery(propertyId, organizationId);

	const { activePlan, hasSubscription, hasPurchase } = createPurchasesHelper(
		purchases ?? [],
	);
	return { purchases, activePlan, hasSubscription, hasPurchase };
};

export const usePropertyPurchases = (propertyId: string) =>
	usePurchases(propertyId);

export const useOrganizationPurchases = (organizationId: string) =>
	usePurchases(undefined, organizationId);
